'use client';

import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, IconButton } from '@/primitives';
import { useTraitSettings } from './TraitSettingsContext';

type EbvGroupHeaderProps = {
  /** Display label and trait-settings category (semantic or colour-slot group name). */
  category: string;
};

export default function EbvGroupHeader({ category }: EbvGroupHeaderProps) {
  const traitSettings = useTraitSettings();

  return (
    <Box
      sx={{
        color: 'text.primary',
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        height: '100%',
        px: 0.5,
      }}
    >
      <Box sx={{ flex: 1, textAlign: 'center' }}>{category}</Box>
      {traitSettings && (
        <IconButton
          aria-label={`Trait settings for ${category}`}
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            traitSettings.openTraitSettings(category);
          }}
          sx={{ flexShrink: 0, color: 'text.secondary' }}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
}
